import React, { useState } from "react"
import "./show_more.scss"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faChevronDown} from '@fortawesome/free-solid-svg-icons'
import {faChevronUp} from '@fortawesome/free-solid-svg-icons'

export default function ShowMore(props) {
  const [showMore, setShowMore] = useState(false)

  return (
    <div className="show-more" >
      <div className={`prompt ${showMore ? "hide" : ""} `} onClick = {() => {setShowMore(!showMore)}}>Show More <FontAwesomeIcon icon = {faChevronDown}/></div>
      <div className={`content ${showMore ? "" : "hide"}`}>
          {props.children}
      </div>
      <div className={`prompt ${showMore ? "" : "hide"}`} onClick = {() => {setShowMore(!showMore)}}>Show Less <FontAwesomeIcon icon = {faChevronUp}/></div>
    </div>
  )
}
